
import React, { useEffect, useState } from "react";
import { Form, Input, Col, Checkbox, Row, Select, message } from 'antd';
import StringHelper from '../../../helpers/StringHelper';
import ValidatorHelper from '../../../helpers/ValidatorHelper';
import moment from 'moment-jalaali';
import { useGeneralStore } from "../../../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../../../store/slices/createReportsSlice";


const faNum = StringHelper.getFarsiNum;

export default function CrmCallHistoryForm({ usrUserID, renewalCall, newRenewalCall, requestId, detailsCall, historyCall }) {


    const reports = useReportsStore()
    const general = useGeneralStore();
    const [form] = Form.useForm();

    const reasons = reports.crmCallReasonReport.data.Reasons;
    const MessageTemplatesData = reports.crmSms.data;
    const MessageTemplatesLoading = reports.crmSms.loading;
    const reasonsLoading = reports.crmCallReasonReport.loading;
    const status = reports.crmCallStatusReport.data.Status;
    const statusLoading = reports.crmCallStatusReport.loading;
    const rawData = reports.crmRequestReport.data;
    const data = Array.isArray(rawData) ? rawData : rawData?.Items;
    const InsuranceLoading = reports.crmRequestReport.loading;
    const loading = reports.crmCallHistoryReport.loading;
    const [comment, setComment] = useState(false);
    const callReasonWatcher = Form.useWatch("reasonId", form);


    useEffect(() => {
        reports.getCrmCallReasonReport();
        reports.getCrmCallStatusReport();
    }, [])
    useEffect(() => {
        if (callReasonWatcher) {
            reports.getCrmSms(callReasonWatcher)
            form.setFieldsValue({
                MessageTemplate: undefined
            });
        }
    }, [callReasonWatcher])


    function handleChange(e) {
        e ? (setComment(true)) : (setComment(false))
    }
    function onFinish(values) {
        const params = {
            IsProtest: values.IsProtest,
            Description: values.description,
            CommentMessage: values.commentMessage && values.commentMessage,
            CallStatus: values.statusId,
            CallReasonId: renewalCall || newRenewalCall ? 20 : values.reasonId,
            UserId: usrUserID,
            InsuranceRequestId: (renewalCall || newRenewalCall || detailsCall) ? requestId : historyCall ? values.InsuranceRequestId : values.InsuranceRequestId,
            MessageTemplateId: values.MessageTemplate,
        };

        reports.postCrmCallHistoryReport({
            params,
            cb: () => {
                (historyCall || renewalCall || newRenewalCall) ?
                    general.ToggleCrmCallHistoryModal(false) :
                    general.ToggleCrmCallModal(false);
            },
            reset: () => form.resetFields(),
            call: () => {
                setComment(false)
                if (usrUserID) {
                    if (historyCall) {
                        setTimeout(() => {
                            reports.getCrmCallHistory(usrUserID);
                        }, 1000);
                    }
                } else message.error("آی دی کاربر یافت نشد")

                if (renewalCall || detailsCall) {
                    setTimeout(() => {
                        reports.getCrmCalls(requestId);
                    }, 1000);
                }
                if (newRenewalCall) {
                    setTimeout(() => {
                        reports.getBusinessRenewalReport();
                    }, 1000);
                }

            }

        })
    }

    function onFinishFailed(errorInfo) {
        form.scrollToField(errorInfo.errorFields[0].typeId, {
            scroll: {
                offsetTop: 65,
            },
        });
    }


    return (
        <div className="Call-history-form">

            <Form
                form={form}
                className="form-style"
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                hideRequiredMark>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item name="IsProtest" valuePropName="checked" >
                            <Checkbox>آیا شکایت داری؟</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="statusId"
                            label="وضعیت تماس"
                            placeholder="انتخاب کنید"
                            rules={ValidatorHelper.required("وضعیت تماس")}>
                            <Select disabled={statusLoading} loading={statusLoading} placeholder="انتخاب کنید">
                                {status && status.map((state) => <Select.Option key={state.Id} value={state.Id}>{state.Title}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    {(!renewalCall && !newRenewalCall) &&
                        <Col span={12}>
                            <Form.Item
                                name="reasonId"
                                label="دلایل تماس"
                                rules={ValidatorHelper.required("دلایل تماس")}>
                                <Select disabled={reasonsLoading} loading={reasonsLoading} placeholder="انتخاب کنید">
                                    {reasons && reasons.map((reason) => <Select.Option key={reason.Id} value={reason.Id}>{reason.Title}</Select.Option>)}
                                </Select>
                            </Form.Item>
                        </Col>
                    }
                    <Col span={24}>
                        <Form.Item
                            name="MessageTemplate"
                            label="قالب پیامک"
                            className="custom-select-overFlow"
                        >
                            <Select
                                style={{ height: 'auto' }}
                                disabled={!callReasonWatcher} loading={MessageTemplatesLoading} placeholder="انتخاب کنید">
                                {MessageTemplatesData && MessageTemplatesData.map((msg) => <Select.Option key={msg.Id} value={msg.Id} >
                                    <span style={{ whiteSpace: "normal" }}>{msg.Title}</span>
                                </Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    {historyCall &&
                        <Col span={24}>
                            < Form.Item label="انتخاب بیمه نامه" name="InsuranceRequestId" >
                                <Select
                                    disabled={InsuranceLoading} loading={InsuranceLoading}
                                    onChange={handleChange}
                                    placeholder="بیمه نامه مورد نظر خود را انتخاب کنید."  >
                                    <Select.Option key="0" value={null}>هیچکدام</Select.Option>
                                    {data && data?.map((item) => (
                                        <Select.Option key={item.InsuranceRequestId} value={item.InsuranceRequestId}>
                                            {item.BranchTitle} , {item.CompanyName} ,  {faNum(moment(item?.CreationTime).format('jYYYY/jMM/jDD'))}  {item.StatusTitle !== "استعلام" ? `, ${item.StatusTitle}` : ""}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>}

                    <Col span={24}>
                        <Form.Item rules={ValidatorHelper.required("توضیحات")} name="description" label="توضیحات" >
                            <Input.TextArea rows={4} />
                        </Form.Item>
                    </Col>
                    {(detailsCall || renewalCall || newRenewalCall || comment) &&
                        <Col span={24}>
                            <Form.Item name="commentMessage" label="یادداشت">
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>}
                    <Col span={24}>
                        <Form.Item>
                            <button type="primary" className="btn btn-primary waves-effect waves-light float-left">
                                <i className={loading ? "bx bx-loader bx-spin" : "bx bx-check-double "}></i>
                                &nbsp;ثبت
                            </button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

        </div>
    )
}